module.exports = __webpack_public_path__ + "img/overlayImage.79b03247.png";